const setupSubmitOnEnter = () => {
  $('.search-text-submit-field').keypress((e) => {
    if (e.which === 13) {
      $(this).closest('form').submit();
    }
  });
};
export default setupSubmitOnEnter;



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/app/assets/javascripts/packs/common/submit.js